// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const formatter = (args: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'RstMax',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;
      let color;

      if (item.RstMax && parseFloat(item.RstMax) > 0) {
        color = 'yellow';
      }

      if (!color) return;

      wjcCore.addClass(elem.cell, color);
    },
  });

export default formatter;
